/**
 * Form advisor choose script
 */
class FinHub_FormStepsAdvisorChoose {
    constructor() {
        this.initState();
    }

    initState() {
        this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
        this.stepFormAdviserWrapper = $('.js-form-adviser');
        this.authStepForm = null;

        if (!this.stepFormAdviserWrapper.length) {
            return;
        }

        this.initFormAdviser();
        this.initSearchAdvisor();

        if (this.hasAuthStep()) {
            this.authStepForm = new FinHub_FormLoginOrRegister();
        }
    }

    initFormAdviser() {
        this.prevStepAdviser = this.stepFormAdviserWrapper.find('.prev-step');
        this.adviserProgressBar = this.stepFormAdviserWrapper.find('.progress-bar');
        this.adviserProgressBarItem = this.adviserProgressBar.find('li');
        this.firstStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="0"]');
        this.secondStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="1"]');
        this.lastStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="2"]');
        this.summaryStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="3"]');
        this.firstNextStepAdviserBtn = this.firstStepForm.find('.next-step');
        this.secondNextStepAdviserBtn = this.secondStepForm.find('.next-step');
        this.submitAdviser = this.stepFormAdviserWrapper.find('.btn-submit');

        this.prevStepAdviser.on('click', e => {
            e.preventDefault();
            this.currentStep = parseInt(this.stepFormAdviserWrapper.attr('data-current-step'), 10);
            let currentStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="' + this.currentStep + '"]');
            let prevStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="' + (this.currentStep - 1) + '"]');

            this.adviserProgressBarItem.eq(this.currentStep).removeClass('active');
            this.adviserProgressBarItem.eq(this.currentStep - 1).addClass('active');
            prevStepForm.addClass('active');
            currentStepForm.removeClass('active');
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#progress-bar").offset().top
            }, 100);

            this.currentStep--;
            this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
        });

        let formHelperStep1 = new FinHub_FormHelper(this.firstStepForm);
        let formHelperStep2 = new FinHub_FormHelper(this.secondStepForm);
        let formHelperLastStepForm = new FinHub_FormHelper(this.lastStepForm)

        formHelperStep1.formDependencies([
            {
                useCollection: true,
                field: 'transaction-type-id',
                dependsOn: 'input[name="transaction_type_id"]',
                elementsToShow: (value) => this.firstStepForm.find('[data-transaction-type-id="' + value + '"]')
            },
            {
                field: 'is_need_finishing',
                dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
                showOn: () => {
                    let selectedTransactionType = this.firstStepForm.find('input[name="transaction_type_id"]:checked');

                    if (!selectedTransactionType.length) {
                        return false;
                    }

                    let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
                    let selectedSubject = this.firstStepForm.find('input[name="transaction_subject_id"]:checked');

                    if (!selectedSubject.length) {
                        return false;
                    }

                    let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');

                    return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
                }
            },
            {
                field: 'need_finishing_amount',
                dependsOn: 'input[name="is_need_finishing"]',
                showOn: (value) => value == 1
            }
        ]);

        this.firstNextStepAdviserBtn.on('click', e => {
            e.preventDefault();
            let result = formHelperStep1.formValidate();
            this.currentStep = 1;

            if (result) {
                this.firstStepForm.addClass('is-loading');

                setTimeout(() => {
                    this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
                    this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                    this.firstStepForm.removeClass('active');
                    this.firstStepForm.removeClass('is-loading');
                    this.secondStepForm.addClass('active');
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#progress-bar").offset().top
                    }, 100);
                }, 1000);
            }
        });

        this.secondNextStepAdviserBtn.on('click', e => {
            e.preventDefault();
            let result = formHelperStep2.formValidate();
            this.currentStep = 2;

            if (result) {
                this.secondStepForm.addClass('is-loading');

                setTimeout(() => {
                    this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
                    this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                    this.secondStepForm.removeClass('active');
                    this.secondStepForm.removeClass('is-loading');
                    this.lastStepForm.addClass('active');
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#progress-bar").offset().top
                    }, 100);
                }, 1000);
            }
        });

        this.submitAdviser.on('click', e => {
            e.preventDefault();
            let result = formHelperLastStepForm.formValidate();
            this.currentStep = 3;

            if (result) {
                this.lastStepForm.addClass('is-loading');

                setTimeout(() => {
                    this.lastStepForm.removeClass('is-loading');
                    this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                    this.lastStepForm.removeClass('active');
                    this.summaryStepForm.addClass('active');

                    if (this.authStepForm) {
                        this.authStepForm.showForm();
                    } else {
                        let form = this.stepFormAdviserWrapper.find('form');

                        $.ajax({
                            type: 'POST',
                            url: form.attr('action'),
                            data: form.serialize(),
                            success: (data) => {
                                console.log(data);
                                this.summaryStepForm.find('.advisor-image img').attr('src', data.adviser.image_url);
                                this.summaryStepForm.find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                                $('.form-step-summary').removeClass('is-hidden');
                                $('.wrapper[data-current-step]').addClass('is-sent-successfully');
                            }
                        });
                    }
                }, 1000);
            }
        });
    }

    initSearchAdvisor() {
        let goToStep3AdvisorFormBtn = $('#go_to_step_3');

        if (!goToStep3AdvisorFormBtn.length) {
            return;
        }

        goToStep3AdvisorFormBtn.click(e => {
            e.preventDefault();
            let postCode = $('input[name="customer_post_code"]').val();
            let cityName = $('input[name="customer_city"]').val();
            $('.advisors-list').addClass('is-loading');
            $('.advisors-list').empty();
            $('input[name="adviser_id"]').val('');
            $('.btn-submit').attr('disabled', true);

            $.post(
                $('.form-adviser-search').attr('data-advisor-search'),
                {
                    address: postCode + ' ' + cityName
                },
                (data) => {
                    if ($('.map.is-active').length) {
                        $('.advisor-map-wrapper').empty();
                        $('.advisor-map-wrapper').removeAttr('style');
                        $('.map').removeClass('is-active');
                    }

                    $('.advisors-list').removeClass('is-loading');
                    window.finhubAdvisersList = [];

                    for (let i = 0; i < data.advisers.length; i++) {
                        this.renderAdvisor(data.advisers[i]);

                        if (data.advisers[i].latitude && data.advisers[i].longitude) {
                            console.log(data);
                            window.finhubAdvisersList.push({
                                id: data.advisers[i].id,
                                name: data.advisers[i].name,
                                surname: data.advisers[i].surname,
                                latitude: parseFloat(data.advisers[i].latitude),
                                longitude: parseFloat(data.advisers[i].longitude)
                            });
                        }
                    }
                }
            );
        });

        $('.advisors-list').on('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#select-advisor') {
                $('.block-advisers__item a[href="#select-advisor"]').removeClass('is-selected');
                $(e.target).addClass('is-selected');
                $('input[name="adviser_id"]').val($(e.target).attr('data-id'));
                $('.btn-submit').attr('disabled', false);
            }
        });
    }

    renderAdvisor(advisorData) {
        let template = `
    <div class="block-advisers__item" data-adviser-id="">
      <div class="block-advisers__item-image">
        <img src="" alt="" loading="lazy">
      </div>
      <div class="block-advisers__item-text" data-featured="{{ $item->promoted == 1 ? 'Tak' : 'Nie' }}">
        <div class="row">
          <div class="block-advisers__item-info">
            <h1 class="block-advisers__item-name"></h1>
            <span class="block-advisers__item-rating">
                <div class="rating-stars" data-rating="">
                    <svg class="star">
                        <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                    </svg>
                    <svg class="star">
                        <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                    </svg>
                    <svg class="star">
                        <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                    </svg>
                    <svg class="star">
                        <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                    </svg>
                    <svg class="star">
                        <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                    </svg>
                </div>
                <span class="block-advisers__item-rating_sum"></span>
            </span>
            <p class="block-advisers__item-desc"></p>
          </div>
          <div class="block-advisers__item-buttons">
            <a href="#select-advisor" data-id="" class="btn btn-primary btn-small">
              ` + this.i18n.choose + `
            </a>
          </div>
        </div>
        <div class="row">
          <span class="block-advisers__item-city">
            <svg class="icon">
              <use xlink:href="./front/images/icons/svg-map.svg#map-marker"></use>
            </svg>
            <span class="block-advisers__item-city-name"></span>
            <span class="block-advisers__item-languages"></span>
          </span>
        </div>
      </div>
    </div>`;
        let templateElement = $(template);
        templateElement.attr('data-adviser-id', advisorData.id);
        templateElement.find('.block-advisers__item-image img').attr('src', advisorData.image_url);
        templateElement.find('.block-advisers__item-name').text(advisorData.name + ' ' + advisorData.surname);
        templateElement.find('.rating-stars').attr('data-rating', Math.round(advisorData.opinions_avg_note));
        templateElement.find('.block-advisers__item-rating_sum').text(advisorData.opinions_count + " opinie");
        templateElement.find('.block-advisers__item-desc').text(advisorData.short_description);
        templateElement.find('.block-advisers__item-buttons .btn-primary').attr('data-id', advisorData.id);
        templateElement.find('.block-advisers__item-city-name').text(advisorData.city);
        for (const value of advisorData.markets) {
            templateElement.find('.block-advisers__item-languages').append(`<img src="${window.location.origin + `/front/images/flags/${value.code}.png`}" alt="${value.name}">`);
        }
        templateElement.find('.block-advisers__item-text').attr('data-featured', advisorData.promoted ? 'Tak' : 'Nie');
        templateElement.appendTo($('.advisors-list'))
    }

    hasAuthStep() {
        let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');

        if (authStep.length) {
            return true;
        }

        return false;
    }
}
